import React from "react";
import { FormFeedback, Input } from "reactstrap";
import TicketBarcodeScannerButton from "./TicketBarcodeScannerButton";

const TicketBarcodeInput = ({
  id,
  label,
  value,
  onChange,
  onKeyDown,
  placeholder,
  disabled = false,
  invalid = false,
  errorMessage = "",
  isRequired = false,
}) => {
  const handleScanResult = scannedValue => {
    onChange(String(scannedValue ?? "").trim());
  };

  return (
    <>
      {label ? (
        <label htmlFor={id} className="form-label">
          {label}
          {isRequired ? <span className="text-danger"> *</span> : null}
        </label>
      ) : null}
      <div className="position-relative ticket-barcode-input">
        <Input
          id={id}
          className="form-control"
          value={value}
          placeholder={placeholder}
          onChange={event => onChange(event.target.value)}
          onKeyDown={onKeyDown}
          disabled={disabled}
          invalid={invalid}
          style={{ paddingRight: "36px" }}
        />
        {!disabled ? (
          <TicketBarcodeScannerButton handleResult={handleScanResult} />
        ) : null}
      </div>
      {errorMessage ? <FormFeedback className="d-block">{errorMessage}</FormFeedback> : null}
    </>
  );
};

export default TicketBarcodeInput;
